import React, { Component } from 'react';
import * as _ from 'lodash';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';

import * as componentActions from '../../../actions/componentActions';
import * as discussionDrawerActions from '../../../actions/discussionDrawerActions';
import * as drawerActions from '../../../actions/drawerActions';
import { getConfiguration, getGroupWithId, MODES } from '../AssignmentsContentPanel/assignmentsContentPanelService';
import { isAfter, isPast } from '../../../utils/dateUtlis';
import DrawerCommonPanel from '../DrawerCommonPanel';
import PanelTextarea from '../CommonComponents/PanelTextarea';
import PanelChoosingCarousel from '../CommonComponents/PanelChoosingCarousel';
import DatesContainer from '../DateSelectorContainer/DatesContainer';
import { DISCUSSION_TABS_CONSTANTS, MAX_LENGTH_VARIABLES } from '../../../const';

class DiscussionsContentPanel extends Component {
  static defaultProps = {
    datesContainerState: { currentDate: dayjs(), hasInteraction: false }
  };

  constructor(props) {
    super(props);
    let deadLine =
      props.discussion && props.discussion.selectedDeadLine
        ? Object.assign({}, props.discussion.selectedDeadLine)
        : undefined;
    let modeCurrent = MODES.CREATE;
    this.state = {
      description: props.discussion.description,
      deadLine,
      modeCurrent
    };
  }

  componentDidMount() {
    const { discussion, mode } = this.props;

    let currentMode = isPast(discussion.dueDate) && mode === MODES.EDIT ? MODES.READ : mode;
    this.setCurrentMode(currentMode);
  }

  setCurrentMode = modeCurrent => {
    this.setState({ modeCurrent });
  };

  createDiscussion = () => {
    const { drawerActions, discussionDrawerActions } = this.props;
    discussionDrawerActions.createNewDiscussion();
    drawerActions.closeDrawerAndRemoveContent();
  };

  editDiscussion = () => {
    const { discussion, drawerActions, discussionDrawerActions } = this.props;
    discussionDrawerActions.editDiscussion(discussion);
    drawerActions.closeDrawerAndRemoveContent();
  };

  onButtonClick = () => {
    const { mode } = this.props;
    if (mode === MODES.CREATE) {
      this.createDiscussion();
    } else if (mode === MODES.EDIT) {
      this.editDiscussion();
    }
  };

  setSelectedGroup = group => {
    const { discussionDrawerActions, mode } = this.props;
    if (getConfiguration(mode).groups) {
      let selectedGroup = getGroupWithId(group);
      discussionDrawerActions.setSelectedGroup(selectedGroup);
    }
  };

  onInputTitle = event => {
    this.props.discussionDrawerActions.setTitle(event.target.value);
  };

  onInputDescription = event => {
    this.props.discussionDrawerActions.setDescription(event.target.value);
  };

  setDeadLine = deadLine => {
    this.props.discussionDrawerActions.setDueDate(deadLine);
  };

  setStartDate = startDate => {
    this.props.discussionDrawerActions.setStartDate(startDate);
  };

  render() {
    const {
      discussion,
      locale,
      groups,
      drawerActions,
      mode,
      activeDiscussionTab,
      openChooseMultiple,
      setDatesContainerInteraction,
      datesContainerState
    } = this.props;
    const { modeCurrent } = this.state;

    let emptyFields = _.isEmpty(discussion.description) || _.isEmpty(discussion.title);
    const invalidStartDateOnCreate =
      mode === MODES.CREATE &&
      (isAfter(discussion.startDate, discussion.dueDate, 'seconds') ||
        isAfter(datesContainerState.currentDate, discussion.startDate, 'seconds'));
    const invalidStartDateOnEdit =
      mode === MODES.EDIT &&
      activeDiscussionTab === DISCUSSION_TABS_CONSTANTS.FUTURE.key &&
      (isAfter(discussion.startDate, discussion.dueDate, 'seconds') ||
        isAfter(datesContainerState.currentDate, discussion.startDate, 'seconds'));
    const invalidDates = invalidStartDateOnCreate || invalidStartDateOnEdit;
    let buttonText = modeCurrent === MODES.EDIT ? 'panels.discussion.save' : 'panels.discussion.createDiscussion';
    const panelHeaderTitle =
      modeCurrent === MODES.EDIT ? 'panels.discussion.editDiscussion' : 'panels.discussion.newDiscussion';

    return (
      <DrawerCommonPanel
        sticky={false}
        closePanel={drawerActions.closeDrawerAndRemoveContent}
        panelHeaderTitle={I18n.t(panelHeaderTitle)}
        hideRowButtons={emptyFields || invalidDates}
        primaryButtonText={buttonText}
        onPrimaryButtonClick={this.onButtonClick}
      >
        <DatesContainer
          disabledStartDate={mode === MODES.EDIT && activeDiscussionTab === DISCUSSION_TABS_CONSTANTS.IN_PROGRESS.key}
          setDatesContainerInteraction={setDatesContainerInteraction}
          datesContainerState={datesContainerState}
          selectDeadLine={this.setDeadLine}
          selectStartDate={this.setStartDate}
          deadLine={discussion.dueDate}
          mode={mode}
          startDate={discussion.startDate}
          locale={locale}
        />
        {mode === MODES.CREATE && (
          <PanelChoosingCarousel
            label={I18n.t('panels.discussion.whoAssigned')}
            groups={groups}
            setSelectedGroup={this.setSelectedGroup}
            mode={mode}
            selectedGroup={discussion.selectedGroup}
            openChooseMultiple={openChooseMultiple}
            students={discussion.students}
          />
        )}
        <PanelTextarea
          className="title-input"
          label={I18n.t('panels.assignment.title')}
          placeholder={`${I18n.t('panels.discussion.addTitle')}`}
          onInput={this.onInputTitle}
          maxCharacters={MAX_LENGTH_VARIABLES.DISCUSSION_NAME}
          value={discussion.title}
        />
        <PanelTextarea
          label={I18n.t('panels.assignment.description')}
          placeholder={`${I18n.t('panels.discussion.addDescription')}`}
          onInput={this.onInputDescription}
          maxCharacters={MAX_LENGTH_VARIABLES.DESCRIPTION}
          value={discussion.description}
        />
      </DrawerCommonPanel>
    );
  }
}

DiscussionsContentPanel.propTypes = {
  locale: PropTypes.string,
  mode: PropTypes.string.isRequired,
  drawerActions: PropTypes.any,
  discussion: PropTypes.object.isRequired,
  openChooseMultiple: PropTypes.any,
  groups: PropTypes.array,
  discussionDrawerActions: PropTypes.object,
  setDatesContainerInteraction: PropTypes.func,
  datesContainerState: PropTypes.object,
  activeDiscussionTab: PropTypes.string
};

function mapStateToProps(state) {
  return {
    activeDiscussionTab: state.discussions.activeDiscussionTab,
    locale: state.i18n.locale,
    groups: state.classrooms.selectedClassroom.groups
  };
}

function mapDispatchToProps(dispatch) {
  return {
    componentActions: bindActionCreators(componentActions, dispatch),
    discussionDrawerActions: bindActionCreators(discussionDrawerActions, dispatch),
    drawerActions: bindActionCreators(drawerActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DiscussionsContentPanel);
